import axios from 'axios';

const getArchiveUrl = (clientId, isArchived) => {
  const toArchive = isArchived ? 'archive' : 'unarchive';

  return `${process.env.REACT_APP_BASE_URL}agency/clients/${clientId}/${toArchive}`;
};

export function archive(toArchive, clientId) {
  return axios.patch(getArchiveUrl(clientId, toArchive));
}

const getChangeUserUrl = (
  clientId,
  producer,
  selectedId,
  csrAgencyId,
  csrId,
  producerAgencyId,
  producerId,
) => {
  if (producer) {
    return `${process.env.REACT_APP_BASE_URL}agency/clients/${clientId}/hub/producers/${selectedId}/agencies/${csrAgencyId}/users/${csrId}`;
  }

  return `${process.env.REACT_APP_BASE_URL}agency/clients/${clientId}/hub/csrs/${selectedId}/agencies/${producerAgencyId}/users/${producerId}`;
};

export function changeUser(
  clientId,
  producer,
  selectedId,
  csrAgencyId,
  csrId,
  producerAgencyId,
  producerId,
) {
  return axios.patch(
    getChangeUserUrl(
      clientId,
      producer,
      selectedId,
      csrAgencyId,
      csrId,
      producerAgencyId,
      producerId,
    ),
  );
}
